import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";

import { goToScene } from "../../main";
import Linda from "../../actors/characters/linda";
import { playerState } from "../../state/stateManager";

export default class LindasHouse extends ex.Scene {
  constructor() {
    super();
    const player = new Player(20 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
    this.linda = new Linda({ x: 14 * 16, y: 6 * 16 }, "lindasHouse");
  }
  onInitialize(engine) {
    Resources.LindasHouse.addToScene(this);
    console.log("lindasHouse: adding player: ", this.player);
    this.player.lastDir = "up";

    this.add(this.player);

    this.camera.zoom = 1;

    this.door = new ex.Trigger({
      pos: new ex.Vector(19 * 16, 19 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 35 * 16, y: 8 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "linda") {
        this.linda.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    // if (content.npcLocations.linda.location == 0) {
    this.add(this.linda);
    // }
  }
  onPostUpdate() {}
}
